<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
             <el-form-item label="供应商名称："> 
                <el-select v-model="searchForm.supplierCode" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name + '(' + item.alias + ')'"></el-option>
                </el-select>
            </el-form-item> 
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getBindPhoneListHandler">搜索查询</el-button>
                 <el-button type="success" @click="changeStateVisible1 = true">添加绑定</el-button>
                <el-button type="primary" @click="confirmExportDialogVisible = true">导 出</el-button> 
            </el-form-item>
            <el-form-item class="btnArea">
                <el-upload ref="upload"  style="display: inline-block;" :show-file-list="false" 
                :action="uploadUrl('bindPhone/import/info')" :headers="setHeader()" 
                :limit="1"  :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>导入手机号</el-button>
                </el-upload> 
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="150"></el-table-column>
            <el-table-column prop="userPhone" label="手机号" width="120"></el-table-column>
            <el-table-column prop="createTime" label="绑定时间" width="150"></el-table-column>
            <el-table-column prop="idcard" label="身份证号" width="150"></el-table-column>
            <el-table-column prop="idcardRemark" label="实名详情" ></el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportHandle">确 定</el-button>
            </span>
        </el-dialog>


         <el-dialog :append-to-body="true"  title="添加绑定" :visible.sync="changeStateVisible1" width="600px" @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm"  label-width="100px">
                <el-form-item label="卡号：" prop="iccid">
                    <el-input v-model="changeStateForm.iccid" placeholder="ICCID或者虚拟号"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="userPhone">
                    <el-input v-model="changeStateForm.userPhone"  placeholder="用户手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="changeStateForm.name" placeholder="(选填)"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idcard">
                    <el-input v-model="changeStateForm.idcard"  placeholder="(选填) "></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>

    </div>
</template>

<script>
import {getBindPhoneList, exportRecord, deleteBindRecord} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            changeStateVisible1:false,
            changeStateForm: {
                iccid: '',
                userPhone: '',
                 name: '',
                idcard: ''
            },
            searchForm: {
                iccid: '',
                userPhone: '',
                supplierCode:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            branchSupplierOption:[],
            confirmExportDialogVisible: false,
        }
    },
    methods: {
          sureChangeStateHandler1(){
             common.sysRequest('bindPhone/insert/bind', this.changeStateForm, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                    this.changeStateVisible1 = false;
                    this.getBindPhoneListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },     
          changeStateCancel(){
             this.changeStateVisible1 = false;
            this.$refs.changeStateForm.resetFields();
        },
               handleSuccess(res){
            this.$refs.upload.clearFiles();
        },
        getBindPhoneListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBindPhoneList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        exportHandle(){
            exportRecord({'supplierCode':this.searchForm.supplierCode}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getBindPhoneListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getBindPhoneListHandler();
        },
        // 添加删除按钮
        handleDelete(index, row) {
            let data = {
                iccid: row.iccid,
            }
            deleteBindRecord(data).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                    message: '删除成功',
                    type: 'success'
                    });
                this.getBindPhoneListHandler();
                }
                else {
                    this.$message.error(res.data.result);
                }
            })
        }
    },
    created(){ 
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
        this.getBindPhoneListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

